import React, { useState } from 'react'
import moment from 'moment'
import DatePicker from 'react-datepicker'

const AbsoluteDateInput = props => {
  const { value, options, preferenceName, storeEdits, otherPreferences } = props

  const date = moment.isMoment(value) ? value : moment(value)
  let maxDate
  let minDate
  // @todo ideally this is instead a flag for hidden and not disabled
  let isDisabled = !otherPreferences.requestDateIsAbsolute
  if (preferenceName === 'requestAbsoluteStopDate') {
    minDate = otherPreferences.requestAbsoluteStartDate && moment.isMoment(otherPreferences.requestAbsoluteStartDate) ? otherPreferences.requestAbsoluteStartDate : moment(otherPreferences.requestAbsoluteStartDate)
  } else if (preferenceName === 'requestAbsoluteStartDate') {
    maxDate = otherPreferences.requestAbsoluteStopDate && moment.isMoment(otherPreferences.requestAbsoluteStopDate) ? otherPreferences.requestAbsoluteStopDate : moment(otherPreferences.requestAbsoluteStopDate)
  }
  return <div className="input-group">
    <span className="input-group-addon">
        <i className="fa fa-calendar"/>
    </span>
    <DatePicker
      disabled={isDisabled}
      fixedHeight={true}
      showYearDropdown
      showMonthDropdown
      peekNextMonth
      className="form-control"
      dateFormat="MM/DD/YYYY"
      selected={date}
      onChange={storeEdits}
      maxDate={maxDate}
      minDate={minDate}
    />
  </div>
}

export default AbsoluteDateInput
